// @flow
export { default } from './CheckoutSuccessTemplate';



// WEBPACK FOOTER //
// ./src/components/checkout/CheckoutSuccessTemplate/index.js